import MessagingBase from './messaging-base';

export default class MessagingMessage extends MessagingBase {
  buildURL(modelName, id, snapshot, requestType, query) {
    let conversationId = id;
    if (query?.conversationId) {
      conversationId = query.conversationId;
      delete query.conversationId;
    } else if (snapshot) {
      conversationId = snapshot.belongsTo('conversation').id;
    }
    return `${this.host}/conversations/${conversationId}/messages`;
  }
}
